module.exports = __webpack_public_path__ + "static/media/VTB_110.ed6d1ed3.png";